import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const CartItemSchema = z.object({
  slug: z.string().min(1).max(128),
  bundleQty: z.number().int().min(1).max(10000),
  qty: z.number().int().min(1).max(10000),
});

const InputSchema = z.object({
  token: z.string().min(8).max(128),
  country: z.string().min(2).max(8),
  currency: z.string().min(2).max(8),
  data: z.object({
    items: z.array(CartItemSchema).max(200),
    couponCode: z.string().max(64).nullable().optional(),
  }),
});

export const mirrorCart = createServerFn({ method: "POST" })
  .inputValidator(InputSchema.parse)
  .handler(async ({ data }): Promise<{ ok: true }> => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    await supabaseAdmin
      .from("ecom_carts")
      .upsert(
        {
          cart_token: data.token,
          country: data.country,
          currency: data.currency,
          data: data.data,
          updated_at: new Date().toISOString(),
        },
        { onConflict: "cart_token" },
      );
    return { ok: true };
  });